import { LocalStorageKeys } from "LocalStorageKeys";
import green from "@material-ui/core/colors/green";
import orange from "@material-ui/core/colors/orange";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import { useLocalStorage } from '@rehooks/local-storage';

if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
  if (localStorage.getItem('theme') === null) {
    localStorage.setItem('theme', 'dark');
  }
}


export function useAppTheme() {
  const [theme] = useLocalStorage(LocalStorageKeys.THEME);
  return createMuiTheme({
    palette: {
      type: theme === 'dark' ? 'dark' : 'light',
      primary: {
        main: green[500],
      },
      secondary: {
        main: orange.A200,
      }
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          a: {
            color: 'inherit',
          }
        }
      }
    }
  })
}
